export const travelUrl = 'https://pw.wawushan666.com/merch/#/travelLogin'
